import cookies from "browser-cookies";
import { v1 as uuidv1 } from "uuid";
import { LDUser, LDOptionsBase } from "launchdarkly-js-sdk-common";
import { cachedStore } from "../helpers/storeHelpers";
import { hasLoginSession } from "../helpers/loginHelpers";
import { ProviderConfig } from "launchdarkly-react-client-sdk/lib/types";
import { AppState } from "../@types";
import { config } from "../config";

export const ldOptions = {
  baseUrl: config.LD_BASE_URL,
  eventsUrl: config.LD_EVENTS_URL,
  streamUrl: config.LD_STREAM_URL,
  fetchGoals: false,
  sendLDHeaders: false,
  streaming: true,
  streamReconnectDelay: 5000,
};

/**
 * Get the most up-to-date values for a Launch Darkly user object
 * @param [state] - Application state from the store
 * @returns - the LaunchDarkly user object
 */
export const getLdUser = (state: AppState | Partial<AppState> = {}): LDUser => {
  const ldUserKey = cookies.get("mct-anonymous-session-id") || uuidv1();
  const mctOec2020 = cookies.get("mctOec2020");

  const ldUser: LDUser = {
    key: ldUserKey,
    anonymous: true,
    custom: {
      /**
       * This does not work immediately on page load after login redirect.
       * @see AppContent.tsx where LD flags are dynamically updated as needed.
       */
      isLoggedIn: hasLoginSession(),
      isCSR: !!state?.beneficiary?.csr_id,
    },
  };

  if (ldUser.custom && mctOec2020) {
    ldUser.custom["oec2020"] = mctOec2020;
  }

  return ldUser;
};

export const ldUser = getLdUser(cachedStore);

export const ldProviderConfig: ProviderConfig & { options: LDOptionsBase } = {
  clientSideID: config.LD_CLIENT_ID,
  user: ldUser,
  options: ldOptions,
};
